import script from "./CarouselDateItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselDateItem.vue?vue&type=script&setup=true&lang=ts"

import "./CarouselDateItem.vue?vue&type=style&index=0&id=591df170&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591df170"]])

export default __exports__